import { replaceParameters } from '@/common-utils/functions/restUtils';
import { client } from '../../../../../../common-utils/libraries/axios/axios';
import merchantUserFields from '../../fields/merchantUserFields';
import CONTRACT_ACCESS from '../apiUrls';

/**
 * @param responseData response.data object
 * @param responseData.name string
 * @param responseData.permissions array
 * @param response
 * @returns Mapped data object
 */
function mapResponseData(response) {
    const data = {};
    Object.keys(response).forEach(key => {
        data[key] = {
            [merchantUserFields.PROFILE_NAME.key]: response[key][merchantUserFields.PROFILE_NAME.key],
            [merchantUserFields.PROFILE_PERMISSIONS.key]: response[key][merchantUserFields.PROFILE_PERMISSIONS.key]
        };
    });
    return data;
}

const queryGetMerchantUserProfiles = (organizationId) => {
    return {
        queryKey: [CONTRACT_ACCESS.MERCHANT_PROFILE.queryKey, organizationId],
        queryFn: async () => {
            const response = await client.get(replaceParameters(CONTRACT_ACCESS.MERCHANT_PROFILE.url, { organizationId: organizationId }));
            return mapResponseData(response.data);
        }
    };
};

export default queryGetMerchantUserProfiles;